export enum AccountTypes {
  Merchant = 'Merchant',
  Delivery = 'Delivery',
}
